<template>
  <div class="title">{{ this.title }}</div>
</template>

<script>
export default {
  name: "titletops",
  props: {
    title: String
  }
};
</script>

<style lang="less" scoped>
.title {
  color: #d5d8db;
  font-size: 14px;
  margin-top: 38px;
  margin-bottom: 17px;
}
</style>
